import type { Route } from 'next';
import { useIntl } from 'react-intl';

import messages from './messages';
import { Copy, Icon, Wrapper } from './styles';

const BackNavButton = ({ href }: { href: Route }) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper href={href}>
			<Icon />
			<Copy>{formatMessage(messages.copy)}</Copy>
		</Wrapper>
	);
};

export default BackNavButton;
